import React from 'react';
import '../../../styles/modes/autoMode.css';

// Algorithm details component
const AlgorithmDetails = ({ algorithmInfo, isLoading }) => {
  if (isLoading) {
    return <p>Loading algorithm information...</p>;
  }

  return (
    <div className="algorithm-details">
      <h5>{algorithmInfo.name}</h5>
      <p className="algorithm-description">{algorithmInfo.description}</p>


    </div>
  );
};

// Default algorithm information (fallback when API doesn't return data)
export const DEFAULT_ALGORITHMS = {
  "nearest_neighbor": {
    name: 'Nearest Neighbor Algorithm',
    description: 'Visit the nearest unvisited point each time'
  }
};

export default AlgorithmDetails; 